import { RadioGroup } from '@mui/material';
import { ChangeEvent, ReactNode } from 'react';

type RadioOption<T> = {
  value: T;
  label: ReactNode;
};

type VyRadioGroupProps<T> = {
  value: T;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  options: { value: T; label: ReactNode }[];
  renderOption: (item: RadioOption<T>, index: number, isActive: boolean) => ReactNode;
  horizontal?: boolean;
};

export const VyRadioGroup = <T,>({
  value,
  onChange,
  options,
  renderOption,
  horizontal,
}: VyRadioGroupProps<T>) => {
  return (
    <RadioGroup
      value={value}
      onChange={onChange}
      row={horizontal}
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: horizontal ? 'row' : 'column',
        rowGap: horizontal ? undefined : '16px',
        columnGap: horizontal ? '16px' : undefined,
      }}
    >
      {options.map((option, index) => {
        const isActive = value === option.value;

        return renderOption(option, index, isActive);
      })}
    </RadioGroup>
  );
};
